import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Menu extends Component {
	render() {
		return (
		<div className="Menu">
			<a href="/engorath2/"><div className="MenuItem"><FontAwesomeIcon icon="map"/> Carte</div></a>
			<a href="/engorath2/personnages"><div className="MenuItem"><FontAwesomeIcon icon="users"/> Personnages</div></a>			
			<a href="/engorath2/univers"><div className="MenuItem"><FontAwesomeIcon icon="globe-asia"/> Univers</div></a>
		</div>
		);
	}
}

export default Menu;
